
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#53CB72","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M16 6h16a3 3 0 013 3v30a3 3 0 01-3 3H16a3 3 0 01-3-3V9a3 3 0 013-3z","opacity":".202"}}),_c('path',{attrs:{"d":"M32 6a3 3 0 013 3v30a3 3 0 01-3 3H16a3 3 0 01-3-3V9a3 3 0 013-3h16zm0 1H16a2 2 0 00-2 2v30a2 2 0 002 2h7.292L34 30.292V9a2 2 0 00-2-2zm2 24.706L24.706 41H32a2 2 0 002-2v-7.294z"}})])])
          )
        }
      }
    